// Legacy platform detection is kept for integrations that genuinely need it, such as BankID.

export function GetUserAgentType(): UserAgentTypeEnum {
  if (typeof navigator === 'undefined') return UserAgentTypeEnum.Other;

  const userAgent = navigator.userAgent;
  if (/windows phone/i.test(userAgent)) {
    return UserAgentTypeEnum.WindowsPhone;
  }
  if (/android/i.test(userAgent)) {
    return UserAgentTypeEnum.Android;
  }
  // iPadOS desktop mode reports itself as macOS, but still exposes touch points.
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  if (isIPadOS || /iPad|iPhone|iPod/i.test(userAgent)) {
    return UserAgentTypeEnum.iOS;
  }
  return UserAgentTypeEnum.Other;
}

export function IsMobileDevice(userAgent?: UserAgentTypeEnum): boolean {
  return (userAgent ?? GetUserAgentType()) !== UserAgentTypeEnum.Other;
}

export function IsTouchOnlyEnvironment(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  const hasCoarsePointer = window.matchMedia('(any-pointer: coarse)').matches;
  const hasFinePointer = window.matchMedia('(any-pointer: fine)').matches;

  return hasCoarsePointer && !hasFinePointer;
}

export enum UserAgentTypeEnum {
  Android = 0,
  iOS = 1,
  WindowsPhone = 2,
  Other = 3,
}
